import styled from 'styled-components'

export const ModalFaq = styled.section<{
  assetBaseUrl: string
}>`
  .faq {
    margin-top: 30px;
    margin-bottom: 30px;

    .faq-item {
      background-color: unset;
      border-top: 1px solid #1d1d1b;
      margin: 0;
      border-bottom: none; // reset Scensum styling

      &::before {
        content: '';
        background-image: url(${(props) => props.assetBaseUrl}/store/layout/assets/accordion-arrow.svg);
        background-repeat: no-repeat;
        width: 20px;
        height: 10px;
        position: absolute;
        right: 19px;
        top: 25px;
        transition: all 0.3s ease-in-out;
      }

      &:not(.closed) {
        &::before {
          transform: rotate(180deg);
        }
      }

      &:last-child {
        border-bottom: 1px solid #1d1d1b;
      }

      .question {
        padding: 20px 55px 20px 0;

        * {
          font-size: 18px;
          font-weight: 400;
        }

        .glyphicon {
          display: none;
        }
      }

      .answer {
        padding: 0 15px 15px;

        @media (max-width: 1199px) {
          padding-right: 0;
          padding-left: 0;
        }

        p {
          margin-bottom: 15px;
        }
      }
    }
  }
`
